__turbopack_context__.v({
  "label": "CheckboxLabel-module__-l0f-W__label" + " " + "cds-t-body",
  "padded": "CheckboxLabel-module__-l0f-W__padded",
});
